module.exports = __webpack_public_path__ + "static/img/ability2.8e511c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ability2.png
// module id = XeCa
// module chunks = 0